import { CommonService } from './_services/common.service';
import { CommonDataService } from './appDataServices/commonDataService';
import { Component, OnInit } from '@angular/core';

import { Platform, NavController } from '@ionic/angular';

import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AuthenticationService, DialogService } from './_services';
import { AppInfoService } from './_services/appInfoService';

import { Router } from '@angular/router';
import { NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from './_services/storage.service';
import { StringConstants } from './_constants/stringConstants';
import { DynamicDataTranslationService } from './_services/dynamicDataTranslationService';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  dark = false;

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private dialogService: DialogService,
    private appInfoService: AppInfoService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private zone: NgZone,
    private translate: TranslateService,
    private storage: StorageService,
    private nav: NavController,
    private commonDataService: CommonDataService,
    private commonService: CommonService,
    private dynamicDataTranslationService: DynamicDataTranslationService
  ) {
    this.initializeTranslation();
    //get user data in storage;
    authenticationService.initUserData();
    this.initializeApp();
  }

  ngOnInit() {
    this.router.events.subscribe(async () => {
      this.dialogService.resetPopups();
     });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.appInfoService.checkUpdateRequired().then((updateData: any) => {
        if (updateData && updateData.update && updateData.packageName) {
          this.appInfoService.processAppUpdate(updateData);
        }
      }).catch(error => {
        console.log(error);
      });
    });

  }

  initializeTranslation() {
    this.commonService.getSupportedLanguages().then((languages: any[]) => {

      if (Array.isArray(languages) && languages.length > 0) {
        const langs = languages.map(val => val.ShortCode);

        this.translate.addLangs(languages.map(val => val.ShortCode));
        this.storage.get(StringConstants.CURRENT_Language).then(lang => {
          if (lang !== null && lang !== undefined && lang !== '') {
            const browserLang = langs.join('|').includes(lang) ? lang : 'en';
            this.translate.setDefaultLang(browserLang);
            this.translate.use(browserLang);
          } else {
            const browserLang = langs.join('|').includes(this.translate.getBrowserLang()) ? this.translate.getBrowserLang() : 'en';
            this.translate.setDefaultLang(browserLang);
            this.translate.use(browserLang);
          }
        });
      } else {

        this.storage.get(StringConstants.CURRENT_Language).then((lang: string) => {

          if (lang !== null && lang !== undefined && lang !== '') {
            const browserLang = lang.match(/en|fr|in/) ? lang : 'en';
            this.translate.setDefaultLang(browserLang);
            this.translate.use(browserLang);
          } else {
            this.translate.addLangs(['en', 'fr', 'in']);
            const browserLang = this.translate.getBrowserLang().match(/en|fr|in/) ? this.translate.getBrowserLang() : 'en';
            this.translate.setDefaultLang(browserLang);
            this.translate.use(browserLang);
          }
        });
        this.commonDataService.getSupportedLanguages().subscribe(languages => {
          this.commonService.storeSupportedLanguages(languages);
          this.initializeTranslation();
        });
      }
    });
    this.dynamicDataTranslationService.initData();
  }
}
